module.exports = __webpack_public_path__ + "static/media/templatetwo22.a429e4f6.png";